import React from 'react';
import Header from 'modules/header/wholesaler/main';
import PurchaseInfo from 'modules/purchase/purchaseInfo';

const PurchaseInfoContainer = () => {
  return (
    <div className="flex w-full flex-col h-[90vh]">
      <Header title="ثبت آگهی خرید" />
      <PurchaseInfo />
    </div>
  );
};

export default PurchaseInfoContainer;
